import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import { getReconciliation, getReconciliationMismatches, getReconciliationFilesList, postReconcile } from "../services/reconciliationServices";

const initialState = {
  data: {},
  mismatchesData: {
    data: [],
    current_page: 1,
    last_page: 1,
    is_last_page: true,
    total_item: 0,
    current_item_count: 0,
  },
  mismatchesLoading: false,
  filesData: {
    data: [],
    current_page: 1,
    last_page: 1,
    is_last_page: true,
    total_item: 0,
    current_item_count: 0,
  },
  filesLoading: false,
};

export const reconciliationGet = createAsyncThunk(
  "reconciliationGet",
  async (payload) => {
    return await getReconciliation(payload);
  }
);

export const reconciliationMismatchesGet = createAsyncThunk(
  "reconciliationMismatchesGet",
  async (payload) => {
    return await getReconciliationMismatches(payload);
  }
);

export const reconciliationFilesListGet = createAsyncThunk(
  "reconciliationFilesListGet",
  async (payload) => {
    return await getReconciliationFilesList(payload);
  }
);

export const reconciliationPost = createAsyncThunk(
  "reconciliationPost",
  async (payload) => {
    return await postReconcile(payload);
  }
);


const reconciliationSlice = createSlice({
  name: "reconciliations",
  initialState,
  reducers: {
    clearReconciliation: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(reconciliationMismatchesGet.pending, (state) => {
      state.mismatchesLoading = true;
    });
    builder.addCase(reconciliationMismatchesGet.fulfilled, (state, action) => {
      state.mismatchesLoading = false;
      state.mismatchesData = action.payload || {};
    });
    builder.addCase(reconciliationMismatchesGet.rejected, (state) => {
      state.mismatchesLoading = false;
    });
    builder.addCase(reconciliationFilesListGet.pending, (state) => {
      state.filesLoading = true;
    });
    builder.addCase(reconciliationFilesListGet.fulfilled, (state, action) => {
      state.filesLoading = false;
      state.filesData = action.payload || {};
    });
    builder.addCase(reconciliationFilesListGet.rejected, (state) => {
      state.filesLoading = false;
    });
  },
});

export default reconciliationSlice.reducer;
export const { clearReconciliation } = reconciliationSlice.actions;
